<template>
	<div id="app" :class="{'logged-in': user.id}">
        <transition name="fade">
            <div class="mobile-back" v-if="$store.state.screenWidth < 980 && $store.state.sidebarOpen">
                <a href="#" @click.prevent="$store.state.sidebarOpen = false" class="menu-toggle">
                    <icon icon="essentials/basics/close-circle"></icon>
                </a>
            </div>
        </transition>
        <loader class="global-loader" :loading="$store.state.loading > 0"></loader>
        <transition name="fade">
            <sidebar></sidebar>
        </transition>
        <perfect-scrollbar :style="{height: height + 'px'}" class="main-scroll">
            <transition name="fade">
                <topbar v-if="user.id"></topbar>
            </transition>
            <transition name="fade" mode="out-in">
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        </perfect-scrollbar>
        <div class="alert-stack">
            <alert v-model="$store.state.errors" type="danger" icon="essentials/alerts/cancel"></alert>
            <alert v-model="$store.state.messages" type="info" icon="essentials/alerts/info-circle"></alert>
            <alert v-model="$store.state.warnings" type="warning" icon="essentials/alerts/exclamation-circle"></alert>
        </div>
        <global-timer></global-timer>
	</div>
</template>

<script>
    export default {
        data() {
            return {
                height: 0
            };
        },
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        sockets: {
            async refresh(data) {
                if(data.logout) {
                    await this._refreshCsrf();
                }
                if(this.$socket.io.engine) {
                    this.$socket.io.engine.close();
                }
                if(data.logout) {
                    this.$store.state.user = new User(null);
                    await this.$navigate('/');
                }
            },
            'set-active-timer': function(data) {
                this.$store.state.timer = data;
            },
            'active-timer': function(data) {
                this.$store.state.timer.duration = data.duration;
                this.$store.state.timer.day = data.day;
            }
        },
        created() {
            window.addEventListener('resize', this.updateHeight);
        },
        destroyed() {
            window.removeEventListener('resize', this.updateHeight);
        },
        methods: {
            updateHeight() {
                this.height = window.innerHeight;
            }
        },
        mounted() {
            this.updateHeight();
        }
    }
</script>